// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2hFUv","resendInfoText":"OnGoingPaymentBox_resendInfoText__TOEoy"};